import React from 'react'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import { BoldTailHeading } from '~/utils/boldTailHeading'
import './UspsWeHelpYou.css'

function ChevronRight() {
  return (
    <svg className="usps-we-help-you__chevron" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M10.1317 37.5C10.1323 36.8372 10.3961 36.2018 10.865 35.7334L23.6517 22.9467C24.0387 22.5598 24.3458 22.1004 24.5552 21.5948C24.7647 21.0892 24.8725 20.5473 24.8725 20C24.8725 19.4528 24.7647 18.9109 24.5552 18.4053C24.3458 17.8997 24.0387 17.4403 23.6517 17.0534L10.8817 4.27503C10.4263 3.80352 10.1743 3.17202 10.18 2.51652C10.1857 1.86103 10.4486 1.234 10.9122 0.770479C11.3757 0.306959 12.0027 0.0440368 12.6582 0.0383407C13.3137 0.0326447 13.9452 0.284631 14.4167 0.740026L27.1867 13.5084C28.9038 15.2288 29.8681 17.5602 29.8681 19.9909C29.8681 22.4215 28.9038 24.7529 27.1867 26.4734L14.4 39.26C14.0509 39.6094 13.6061 39.8475 13.1218 39.9443C12.6375 40.0412 12.1353 39.9924 11.6787 39.8041C11.2221 39.6158 10.8315 39.2965 10.5561 38.8864C10.2808 38.4764 10.1331 37.9939 10.1317 37.5V37.5Z" fill="#F9DC72" />
    </svg>
  )
}

export default function UspsWeHelpYou({ section, index, className = '' }) {
  const { usps, textCard } = section
  // Content mapping is by visual role, not by WP field name: the CMS "heading"
  // field holds the short "We help you..." label, "subheading" holds the big
  // 36px headline, and "content" holds the subtitle underneath it.
  const title = textCard?.subheading
  const subtitle = textCard?.content
  const label = textCard?.heading?.text

  if (!usps || !usps.length) {
    return null
  }

  return (
    <section id={section.fieldGroupName + index} className={`usps-we-help-you ${className}`}>
      <div className="container">
        {(title || subtitle) && (
          <div className="usps-we-help-you__header">
            {title && (
              <h2 className="usps-we-help-you__heading">
                <BoldTailHeading text={title} />
              </h2>
            )}
            {subtitle && (
              <div className="usps-we-help-you__subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
            )}
          </div>
        )}

        <div className="usps-we-help-you__body">
          {label && <p className="usps-we-help-you__label">{label}</p>}

          <div className="usps-we-help-you__row">
            {usps.map((usp, i) => (
              <React.Fragment key={`weHelpYou${i}`}>
                <FadeInWhenVisible transition={{ delay: `${i * 0.05}` }}>
                  <div className="usps-we-help-you__card">
                    <div className="usps-we-help-you__card-top">
                      <div className="usps-we-help-you__card-media">
                        {usp.image && (
                          <Image data={usp.image} className="usps-we-help-you__card-image" objectFit="cover" />
                        )}
                      </div>

                      {usp.heading && (
                        <div className="usps-we-help-you__badge">
                          {i + 1}. {usp.heading}
                        </div>
                      )}
                    </div>

                    {usp.content && (
                      <p className="usps-we-help-you__card-content">{usp.content}</p>
                    )}
                  </div>
                </FadeInWhenVisible>

                {i < usps.length - 1 && <ChevronRight />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
